/**
 * Fiscal Printer - fiscal-agent API helpers
 * Used when printing is delegated to the backend fiscal agent queue.
 */
import api from '../api';

/**
 * Queue a coupon document for printing via fiscal-agent.
 */
export async function printCouponDocumentViaAgent(documentData) {
  try {
    const response = await api.post('/fiscal-agent/queue/coupon-document', documentData);
    const data = response.data;
    if (data.success) {
      return { success: true, message: 'Dokument dodany do kolejki druku', job_id: data.data.job_id };
    }
    return { success: false, error: data.message || 'Blad wysylania do kolejki' };
  } catch (error) {
    console.error('Blad API fiscal-agent:', error);
    return { success: false, error: error.message };
  }
}

/**
 * Queue a non-fiscal document for printing via fiscal-agent.
 */
export async function printNonFiscalViaAgent(title, lines, footer = '') {
  try {
    const response = await api.post('/fiscal-agent/queue/non-fiscal', { title, lines, footer });
    const data = response.data;
    if (data.success) {
      return { success: true, message: 'Dokument dodany do kolejki druku', job_id: data.data.job_id };
    }
    return { success: false, error: data.message || 'Blad wysylania do kolejki' };
  } catch (error) {
    console.error('Blad API fiscal-agent:', error);
    return { success: false, error: error.message };
  }
}
